import { Injectable, inject } from '@angular/core';
import { DialogService } from '@next/core-lib/dialog';
import { LocaleService } from '@next/core-lib/i18n';
import { WindowServiceInjector, WindowService } from '@next/core-lib/window';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, of, filter } from 'rxjs';

import { openTermsAndConditionsDialog, openTermsAndConditionsDialogSuccess } from './actions';
import { TermsAndConditionsComponent } from '../shared/components/terms-and-conditions/terms-and-conditions.component';

import { mestplaceTermsAndConditionsAcceptedCookie } from '../shared/cookies';

@Injectable()
export class AppEffects {
  private readonly dialogService = inject(DialogService);
  private readonly actions$ = inject(Actions);
  private readonly localeService = inject(LocaleService);
  private readonly window = inject<WindowService>(WindowServiceInjector);

  openTermsAndConditionsDialog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(openTermsAndConditionsDialog),
      filter(() => {
        const cookie = this.window.getCookie(mestplaceTermsAndConditionsAcceptedCookie);
        return !(cookie === 'true');
      }),
      switchMap((_) =>
        this.dialogService.dialog(
          TermsAndConditionsComponent,
          {
            title: this.localeService.translate('terms-and-conditions.title'),
            confirmButton: true,
            confirmButtonText: this.localeService.translate('terms-and-conditions.confirm-text'),
            cancelButton: false,
            disableClose: true,
            disableCancelAfterDropdownClick: true,
          },
          {},
        ),
      ),
      switchMap(() => of(openTermsAndConditionsDialogSuccess())),
    ),
  );
}
